var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVerifyEmail({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_dd_311_5189)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 15,
    y: 5,
    width: 89.5,
    height: 89.5,
    rx: 13.0976,
    fill: "#B3D7FF",
    fillOpacity: 0.35,
    style: {
      fill: "#B3D7FF",
      fill: "color(display-p3 0.7020 0.8431 1.0000)",
      fillOpacity: 0.35
    },
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.125 34.6274H40.1719C39.2065 34.6274 38.4238 35.4101 38.4238 36.3755V64.3442C38.4238 65.3097 39.2065 66.0923 40.1719 66.0923H82.125C83.0904 66.0923 83.873 65.3097 83.873 64.3442V36.3755C83.873 35.4101 83.0904 34.6274 82.125 34.6274Z",
    fill: "#D9D9D9",
    fillOpacity: 0.2,
    stroke: "#173BE8",
    style: {
      fill: "#D9D9D9",
      fill: "color(display-p3 0.8510 0.8510 0.8510)",
      fillOpacity: 0.2,
      stroke: "#173BE8",
      stroke: "color(display-p3 0.0902 0.2314 0.9098)",
      strokeOpacity: 1
    },
    strokeWidth: 2.79688,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.1719 34.8335L60.6823 47.8856",
    stroke: "#173BE8",
    style: {
      stroke: "#173BE8",
      stroke: "color(display-p3 0.0902 0.2314 0.9098)",
      strokeOpacity: 1
    },
    strokeWidth: 2.79688,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.1929 34.8335L60.6825 47.8856",
    stroke: "#173BE8",
    style: {
      stroke: "#173BE8",
      stroke: "color(display-p3 0.0902 0.2314 0.9098)",
      strokeOpacity: 1
    },
    strokeWidth: 2.79688,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M73.067 57.4293L72.1662 61.6543H71.0771L71.978 57.4293H73.067ZM77.6494 60.1574L78.2228 58.5708L78.5528 60.1574H77.6494ZM78.8647 61.6543H79.8721L78.993 57.4293H78.063C77.8541 57.4293 77.6778 57.5513 77.5994 57.7393L75.9653 61.6543H77.109L77.3361 61.0234H78.7335L78.8647 61.6543ZM76.022 60.2748C76.0266 59.1597 74.4851 59.0983 74.4958 58.6001C74.499 58.4485 74.643 58.2874 74.9577 58.2461C75.114 58.2257 75.5438 58.2099 76.0318 58.4353L76.2229 57.5394C75.9608 57.4439 75.6235 57.3521 75.204 57.3521C74.1276 57.3521 73.3697 57.9264 73.3634 58.7488C73.3566 59.357 73.9042 59.6962 74.317 59.8985C74.7413 60.1056 74.8838 60.2383 74.882 60.4234C74.8792 60.7071 74.5435 60.832 74.2303 60.837C73.6826 60.8457 73.3649 60.6886 73.1115 60.5702L72.9141 61.4959C73.1686 61.6132 73.6382 61.7151 74.1256 61.7204C75.2696 61.7204 76.0182 61.153 76.022 60.2748ZM71.5105 57.4293L69.7458 61.6543H68.5943L67.726 58.2825C67.6732 58.0748 67.6274 57.9988 67.467 57.9113C67.2055 57.7688 66.7731 57.635 66.3926 57.5521L66.4187 57.4293H68.2718C68.508 57.4293 68.7205 57.5871 68.7741 57.86L69.2328 60.3051L70.3663 57.4293H71.5105Z",
    fill: "#173BE8",
    style: {
      fill: "#173BE8",
      fill: "color(display-p3 0.0902 0.2314 0.9098)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 69.5391,
    y: 25.188,
    width: 22.3746,
    height: 22.3746,
    rx: 11.1873,
    fill: "#173BE8",
    style: {
      fill: "#173BE8",
      fill: "color(display-p3 0.0902 0.2314 0.9098)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.8538 33.1128L79.3279 39.6387L76.0649 36.3758",
    stroke: "white",
    style: {
      stroke: "white",
      strokeOpacity: 1
    },
    strokeWidth: 1.24303,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_dd_311_5189",
    x: 0,
    y: 0,
    width: 119.5,
    height: 119.5,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 3,
    operator: "erode",
    in: "SourceAlpha",
    result: "effect1_dropShadow_311_5189"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 10
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 9
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_311_5189"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 4,
    operator: "erode",
    in: "SourceAlpha",
    result: "effect2_dropShadow_311_5189"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_311_5189",
    result: "effect2_dropShadow_311_5189"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_311_5189",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVerifyEmail);
export default __webpack_public_path__ + "static/media/verify-email.0c3c1452dc297958065ab1b11ded6833.svg";
export { ForwardRef as ReactComponent };